import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-row">
        <span className="footer-mark">EN</span>
        <span className="footer-meta">
          eduardonunez.dev · {year}
        </span>
      </div>
      <div className="footer-row">
        <span className="footer-meta">
          Built with React + Framer Motion. Deployed on Netlify.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
